import { createFileRoute } from "@tanstack/react-router";
import AdminUserOrganizationsPage from "@/pages/admin/users/detail/organizations";
import { useUsersPermissions } from "@/pages/admin/users";

export const Route = createFileRoute("/app/admin/users/$userId/organizations/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useParams();
  const { userCanEditAllUsers, userCanViewAllUsers } = useUsersPermissions();

  return (
    <AdminUserOrganizationsPage
      subjectUserId={Number(userId)}
      userCanEditAllUsers={userCanEditAllUsers}
      userCanViewAllUsers={userCanViewAllUsers}
    />
  );
}
